// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2aRyi","footer":"ModalFilter_footer__3j0x-"};